import { ServerConfigInterface } from '@/services/Server/Interfaces'
import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface'
import { validateSync } from 'class-validator'
import IPv4 from '../../Utilities/ipv4'

export default class UpdateServerForm {
  public hostname: string = ''
  public type: string = ''
  public services: string[] = []
  public config: ServerConfigInterface = {
    ips: [],
    dns_ip: '',
  }

  public status: string = ''

  public availableServices: string[] = []

  public rules: { [key: string]: FormValidationFunction[] } = {
    hostname: [
      (v: string) => !!v || 'Server Name or Hostname is required',
      (v: string) => v.length > 1 || 'Server Name or Hostname should be at least 2 characters long',
    ],
    type: [
      (v: string) => !!v || 'Please select server type',
    ],
    services: [
      (v: string[]) => v.every((service: string) => this.availableServices.includes(service)) || 'Invalid service provided',
    ],
    status: [
      (v: string) => !!v || 'Please select server status',
    ],
    ips: [
      (v: string[]) => {
        const ipObj = new IPv4();
        for (const ip of v) {
          ipObj.ip = ip;

          const err = validateSync(ipObj);
          if (err.length > 0) {
            return `'${ip}' is not a valid IP address`;
          }
        }

        return true;
      }
    ],
    dns_ip: [
      (v: string) => !!v || 'Please provide a DNS IP',
      (v: string) => {
        const ipObj = new IPv4();
        ipObj.ip = v;

        const err = validateSync(ipObj);
        if (err.length > 0) {
          return `Provided value is not a valid IP address.`;
        }

        return true
      }
    ],
  }
}
